import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { BancaOnlineSubmissionService } from 'src/app/feature-module/investigation-queue/service/banca-online-submission/banca-online-submission.service';
import { BancaPatientCategory } from 'src/app/utility/enum/global-enum';
import { EnumService } from 'src/app/utility/services/enum-service/enum.service';
import { FileHandlerService } from 'src/app/utility/services/file-handler/file-handler.service';
import { MessageService } from 'src/app/utility/services/message/message.service';
import { PersonNameValidator } from 'src/app/utility/validator/person-name.validator';
import { PhoneValidator } from 'src/app/utility/validator/phone.validator';


@Component({
  selector: 'app-online-generate-input-banca',
  templateUrl: './online-generate-input-banca.component.html',
  styleUrls: ['./online-generate-input-banca.component.scss']
})
export class OnlineGenerateInputBancaComponent implements OnInit {

  formDirectiveInputGeneration: FormGroupDirective;

  today = new Date();
  groupPolicyList: any[] = [];
  filteredGroupPolicyList: any[] = [];
  enrolList: any[] = [];
  filteredEnrolList: any[] = [];
  claimTypes: any[] = [];
  // bancaDeathCauses: any[] = [];
  bancaCauseOfIncidents: any[] = [];
  patientList: any[] = [];
  filteredPatientList = [];
  productList: any[] = [];
  claimTypePrefixChanged:string;
  selectedPolicyId: number;
  selectedEnrolId: number;
  selectedEnrolDependentId: number;
  selectedClaimTypeId: number;
  selectedGroupPolicyId: number;

  bancaOnlineSubmissionForm: FormGroup = this.fb.group({
    id: [0],
    groupPolicy: [null],
    groupPolicyId: [null, [Validators.required]],
    enrol: [null],
    certificateNumber: ['', [Validators.required]],
    insuredName: ['', [Validators.required, Validators.maxLength(200)]],
    insuredDOB: ['', [Validators.required]],
    insuredEffectiveDate: ['', [Validators.required]],
    patient: [null],
    patientName: ['', [Validators.required, Validators.maxLength(200)]],
    patientDOB: [''],
    enrolId: [null],
    enrolDependentId: [null],
    titleOfPolicy: ['', [Validators.maxLength(200)]],
    occupation: ['', [Validators.maxLength(200)]],
    dateOfIncident: ['', [Validators.required]],
    causeOfIncident: [null],
    claimAmount: [null, [Validators.required, Validators.min(0), Validators.max(999999999.99)]],
    claimAmountInUSD: [null, [Validators.min(0), Validators.max(999999999.99)]],
    totalClaimAmount: [null, [Validators.min(0), Validators.max(999999999.99)]],
    claimTypeId: [null, [Validators.required]],
    detailOfClaim: [null, [Validators.maxLength(500)]],
    //products: [null, [Validators.required]],
    bancaClaimSubmissionBeneficiaries: this.fb.array([]),
    bancaClaimSubmissionProducts: this.fb.array([]),
  });

  @Output() onValidInput = new EventEmitter<any>();
  @Output() onClaimTypeChange = new EventEmitter<any>();

  constructor(
    private fb: FormBuilder,
    private bancaOnlineSubmissionService: BancaOnlineSubmissionService,
    private messageService: MessageService,
    private enumService: EnumService,
    private fileHandlerService: FileHandlerService
  ) { }

  ngOnInit() {
    this.getBancaGroupPolicies();
    this.setSubscriber();
    this.GetBancassurances();
    this.getBancaCauseOfIncidents();
    this.addBeneficiaryPersonFormGroup();
    this.getAllBancassuranceProduct();
  }

  getBancaGroupPolicies() {
    this.bancaOnlineSubmissionService.getBancaGroupPolicyNumbers().subscribe(
      res => {
        this.groupPolicyList = res;
        this.filteredGroupPolicyList = res;
      },
      err => {
        this.messageService.show(err.error.message, "error");
      });
  }


  setSubscriber() {
    this.bancaOnlineSubmissionForm.controls['groupPolicy'].valueChanges
      .pipe(debounceTime(10))
      .subscribe(c => {
        if (c && typeof (c) == 'string') {
          this.filteredGroupPolicyList = this.groupPolicyList.filter(x => x.groupNumber.toLowerCase().
            includes(c.toLowerCase()));

        } else {
          this.filteredGroupPolicyList = this.groupPolicyList;
        }
      });

    this.bancaOnlineSubmissionForm.controls['enrol'].valueChanges
      .pipe(debounceTime(300))
      .subscribe(c => {
        if (c && typeof (c) == 'string' && c.length > 2) {
          // this.filteredEnrolList = this.enrolList.filter(x => x.certificateNumber.toLowerCase().
          //   includes(c.toLowerCase()));
          this.getEnrolsByGroupPolicyId(this.selectedGroupPolicyId, c);

        } else {
          this.filteredEnrolList = this.enrolList;

        }
      });

    this.bancaOnlineSubmissionForm.controls['patient'].valueChanges
      .pipe(debounceTime(10))
      .subscribe(c => {
        if (c && typeof (c) == 'string') {
          this.filteredPatientList = this.patientList.filter(x => x.name.toLowerCase().
            includes(c.toLowerCase()));

        } else {
          this.filteredPatientList = this.patientList;

        }
      });
  }

  GetBancassurances() {
    this.bancaOnlineSubmissionService.GetAllActiveBancassurance().subscribe(res => {
      this.claimTypes = res;
    },
      err => {
        this.messageService.show(err.error.message, "error");
      });
  }

  getBancaCauseOfIncidents() {
    this.enumService.getBancaCauseOfIncident().subscribe(res => {
      this.bancaCauseOfIncidents = res;
    },
      err => {
        this.messageService.show(err.error.message, "error");
      });
  }

  getAllBancassuranceProduct() {
    this.bancaOnlineSubmissionService.getAllBancassuranceProduct().subscribe(res => {
      this.productList = res;
    },
      err => {
        this.messageService.show(err.error.message, "error");
      });
  }

  // getBancaClaimSubmissionProductsFormArray(): FormArray {
  //   let  bancaClaimSubmissionProductsFormArray = this.bancaOnlineSubmissionForm.get('bancaClaimSubmissionProducts') as FormArray
  //   return  bancaClaimSubmissionProductsFormArray
  // }

  addBeneficiaryPersonFormGroup() {
    let beneficiaryPersonsFormArray = this.getBeneficiaryInfosFormArray();
    var IsBlank = this.checkBlankEntry(beneficiaryPersonsFormArray.value);
    var duplicateIndexArray = this.findDuplicate(beneficiaryPersonsFormArray.value);

    if (IsBlank) {
      this.messageService.show('Blank data found in Beneficiary section', 'error');
      return;
    }

    else if (duplicateIndexArray.length > 0) {
      this.messageService.show('Same Beneficiary and Contact number can not be inserted', 'error');
      return;
    }
    else {
      beneficiaryPersonsFormArray.push(this.fb.group({
        id: [0],
        name: ['', [Validators.maxLength(200), PersonNameValidator]],
        contactNumber: ['', [Validators.maxLength(11), PhoneValidator]],
      }));
      this.bancaOnlineSubmissionForm.updateValueAndValidity();
    }
  }

  checkBlankEntry(dataList) {
    if (dataList.length > 0) {
      if (dataList.find(element => (element.name == undefined || element.name == null || element.name == '') &&
        (element.contactNumber == undefined || element.contactNumber == null || element.contactNumber == ''))) {
        return true;
      }
    }
    return false;
  }

  findDuplicate(array) {
    let duplicateIndexArray = [];
    let uniqueArray = [];
    duplicateIndexArray = array.filter(o => {
      if (uniqueArray.find(i => i.name === o.name && i.contactNumber === o.contactNumber)) {
        return true
      }
      uniqueArray.push(o)
      return false;
    })
    return duplicateIndexArray;
  }

  removeBeneficiaryPerson(personId: number, index: number) {
    let beneficiaryInfosFormArray = this.getBeneficiaryInfosFormArray();
    beneficiaryInfosFormArray.removeAt(index);

    if (beneficiaryInfosFormArray.length === 0) this.addBeneficiaryPersonFormGroup();
  }

  onPolicyChanged = (event: any): void => {
    this.filteredEnrolList = this.enrolList = this.filteredPatientList = this.patientList = [];
    const entity = this.bancaOnlineSubmissionForm.getRawValue();

    if (event.option.value) {
      let selectedGroupPolicy: any = event.option.value;
      this.bancaOnlineSubmissionForm.patchValue(
        {
          groupPolicy: selectedGroupPolicy,
          groupPolicyId: selectedGroupPolicy.id,
          titleOfPolicy: selectedGroupPolicy.titleOfPolicy,
          enrol: null,
          certificateNumber: null,
          insuredName: null,
          insuredDOB: null,
          insuredEffectiveDate: null,
          patient: null,
          patientName: null,
          patientDOB: null,
          enrolId: null,
          enrolDependentId: null,
        });

      this.selectedGroupPolicyId = selectedGroupPolicy.id,
      this.getEnrolsByGroupPolicyId(selectedGroupPolicy.id, '');
    }

  }

  onEnrolChanged = (event: any): void => {
    this.filteredPatientList = this.patientList = [];
    const entity = this.bancaOnlineSubmissionForm.getRawValue();

    if (event.option.value) {
      let selectedEnrol: any = event.option.value;

      this.bancaOnlineSubmissionForm.patchValue({
        enrol: selectedEnrol,
        insuredDOB: selectedEnrol.birthDate,
        insuredName: selectedEnrol.fullName,
        insuredEffectiveDate: selectedEnrol.effectiveDate,
        certificateNumber: selectedEnrol.certificateNumber,
        patient: null,
        patientName: null,
        patientDOB: null,
        enrolId: selectedEnrol.id,
        enrolDependentId: null,
      });

      this.getPatientByEnrolId(selectedEnrol.id);
    }
  }

  onPatientChanged = (event: any): void => {
    const entity = this.bancaOnlineSubmissionForm.getRawValue();

    if (event.option.value) {
      let selectedPatient: any = event.option.value;

      this.bancaOnlineSubmissionForm.patchValue({
        patient: selectedPatient,
        patientName: selectedPatient.name,
        patientDOB: selectedPatient.dateOfBirth,
      });

      if (selectedPatient.patientCategory == BancaPatientCategory.Enrol) {
        this.bancaOnlineSubmissionForm.patchValue({ enrolId: selectedPatient.id });
        this.bancaOnlineSubmissionForm.patchValue({ enrolDependentId: null });
      } else if (selectedPatient.patientCategory == BancaPatientCategory.EnrolDependent) {
        //In this form there will always be an enrolId because without selecting Insured no data will loaded in patient section
        this.bancaOnlineSubmissionForm.patchValue({ enrolDependentId: selectedPatient.id });
      }
    }

  }


  // onProductSelectionChange(event) {
  //   let products = event.value;

  //    let bancaClaimSubmissionProductsFormArray = this.getBancaClaimSubmissionProductsFormArray();
  //    bancaClaimSubmissionProductsFormArray.clear();
  //     products.forEach(element => {
  //       bancaClaimSubmissionProductsFormArray.push(this.fb.group({
  //         id: [0],
  //         productId: [element.id, [Validators.required]],
  //       }));
  //     });

  //     this.bancaOnlineSubmissionForm.updateValueAndValidity();

  // }

  getBeneficiaryInfosFormArray(): FormArray {
    return this.bancaOnlineSubmissionForm.get('bancaClaimSubmissionBeneficiaries') as FormArray

  }


  resetBeneficiaryFormGroup() {
    let beneficiaryPersonsFormArray = this.getBeneficiaryInfosFormArray();
    beneficiaryPersonsFormArray.clear();

    beneficiaryPersonsFormArray.push(this.fb.group({
      id: [0],
      name: ['', [Validators.maxLength(200), PersonNameValidator]],
      contactNumber: ['', [Validators.maxLength(11), PhoneValidator]],
    }));
    this.bancaOnlineSubmissionForm.updateValueAndValidity();
  }

  validatePolicyInput() {

    const entity = this.bancaOnlineSubmissionForm.getRawValue();

    if (!entity.groupPolicy) {
      this.bancaOnlineSubmissionForm.patchValue({
        groupPolicy: null,
        titleOfPolicy: null,
        enrol: null,
        certificateNumber: null,
        insuredName: null,
        insuredDOB: null,
        insuredEffectiveDate: null,
        patient: null,
        patientName: null,
        patientDOB: null,
        enrolId: null,
        enrolDependentId: null,
      });
      this.bancaOnlineSubmissionForm.updateValueAndValidity();
    }
  }

  validateEnrolInput() {
    const entity = this.bancaOnlineSubmissionForm.getRawValue();

    if (!entity.enrol) {
      this.bancaOnlineSubmissionForm.patchValue({
        insuredDOB: null,
        insuredName: null,
        insuredEffectiveDate: null,
        certificateNumber: null,
        patient: null,
        patientName: null,
        patientDOB: null,
        enrol: null,
        enrolId: null,
        enrolDependentId: null,
      });
      this.bancaOnlineSubmissionForm.updateValueAndValidity();
    }

  }

  validatePatientInput() {
    const entity = this.bancaOnlineSubmissionForm.getRawValue();

    if (!entity.patient) {
      this.bancaOnlineSubmissionForm.patchValue({
        patient: null,
        patientName: null,
        patientDOB: null,
      });
      this.bancaOnlineSubmissionForm.updateValueAndValidity();
    }

  }

  displayPolicyName(item: any): string {
    return item && item.groupNumber ? item.groupNumber : '';
  }

  displayCertificiateName = (enrol: any): string => {
    let certificateNumber: string = '';
    if (enrol && enrol.certificateNumber) {
      certificateNumber = enrol.certificateNumber;
    }
    return certificateNumber;
  }

  displayPatientName = (patient: any): string => {
    let patientName: string = '';
    if (patient && patient.name) {
      patientName = patient.name;
    }
    return patientName;
  }

  getEnrolsByGroupPolicyId(groupPolicyId: number, searchText: string) {

    this.bancaOnlineSubmissionService.getEnrolsByBancaGroupPolicyId(groupPolicyId, searchText).subscribe(
      res => {
        if (res.data) {
          this.enrolList = res.data;
          this.filteredEnrolList = res.data;
        }

      },
      err => {
        this.messageService.show(err.error.message, "error");
      });
  }

  getPatientByEnrolId(enrolId: number) {

    this.bancaOnlineSubmissionService.getPatientListByGroupPolicyId(enrolId).subscribe(
      res => {
        if (res) {
          this.patientList = res;
          this.filteredPatientList = res;
        }

      },
      err => {
        this.messageService.show(err.error.message, "error");
      });
  }

  removeBlankEntryFromBeneficiaryForm() {
    let beneficiaryPersonsFormArray = this.getBeneficiaryInfosFormArray();
    if (beneficiaryPersonsFormArray.value.length > 0) {
      let data: any[] = beneficiaryPersonsFormArray.value;

      data.forEach(x => {
        if (x.name === '' && x.contactNumber === '') {
          let index = beneficiaryPersonsFormArray.value.indexOf(x);
          beneficiaryPersonsFormArray.removeAt(index);
        }

      });

    }
  }

  save(formDirective: FormGroupDirective) {
    this.removeBlankEntryFromBeneficiaryForm();
    const entity = this.bancaOnlineSubmissionForm.getRawValue();

    entity.groupPolicy = entity.enrol = entity.patient = null;

    if (entity['id'] > 0) {
      this.bancaOnlineSubmissionService.edit(entity['id'], entity).subscribe(
        res => {
          this.messageService.show(this.messageService.msgUpdate, 'success');
          this.resetFrom(formDirective);
          this.resetBeneficiaryFormGroup();
        },
        err => {
          this.messageService.show(err.error, "error");
        });

    } else {

      this.bancaOnlineSubmissionService.add(entity).subscribe(
        res => {
          this.messageService.show(this.messageService.msgSave, 'success');
          this.resetFrom(formDirective);
          this.resetBeneficiaryFormGroup();
        },
        err => {
          this.messageService.show(err.error, "error");
        });
    }

  }

  resetFrom(formDirective: FormGroupDirective) {
    if (formDirective != null) {
      formDirective.resetForm();
    }
    this.bancaOnlineSubmissionForm.reset(
      {
        id: 0,
      }
    );
  }

  goToUploadDocument(formDirective1: FormGroupDirective) {
    this.formDirectiveInputGeneration = formDirective1;

    this.removeBlankEntryFromBeneficiaryForm();
    this.notifyParentComponent();
  }

  notifyParentComponent() {

    let entity = this.bancaOnlineSubmissionForm.getRawValue();
    let pdfFormData = this.getBancaClaimFormReport(entity);
    let claimType = this.claimTypes.find(x => x.id == entity.claimTypeId)
    entity.claimTypePrefix = claimType.prefixNumber;
    entity.claimsTypeName = claimType.claimsTypeName;
    entity.pdfFormData = pdfFormData;

    entity.groupPolicy = entity.enrol = entity.patient = null;

    if(this.claimTypePrefixChanged != entity.claimTypePrefix){
      this.onClaimTypeChange.emit(true);
    }
    else{
      this.onClaimTypeChange.emit(false);
    }
    this.claimTypePrefixChanged = entity.claimTypePrefix;

    this.onValidInput.emit(entity);

    this.selectedPolicyId = entity.groupPolicyId;
    this.selectedEnrolId = entity.enrolId;
    this.selectedEnrolDependentId = entity.enrolDependentId;
    this.selectedClaimTypeId = entity.claimTypeId;
    //this.selectedProducts = entity.products;

    this.addBeneficiaryPersonFormGroup();
  }

  resetFromSettings() {
    if (this.formDirectiveInputGeneration != null) {
      this.formDirectiveInputGeneration.resetForm();
    }
    this.bancaOnlineSubmissionForm.reset({ id: 0 });
    this.resetBeneficiaryFormGroup();
    this.claimTypePrefixChanged = '';
  }

  // isProductchanged(data: any): boolean
  // {

  // //  if(this.selectedPolicyId && (this.selectedPolicyId != data.groupPolicyId)){
  // //    return false;
  // //  }
  // //  else if(this.selectedEnrolId && (this.selectedEnrolId != data.enrolId))
  // //  {
  // //    return false;
  // //  }
  // //  else if(this.selectedEnrolDependentId && (this.selectedEnrolDependentId != data.enrolDependentId))
  // //  {
  // //    return false;
  // //  }
  // //  else if(this.selectedClaimTypeId && (this.selectedClaimTypeId != data.claimTypeId))
  // //  {
  // //   return false;
  // //  }
  // //  else
  // if(this.selectedProducts && (this.selectedProducts != data.products))
  //  {
  //   return false;
  //  }

  //  return true;
  // }

  getBancaClaimFormReport(entity: any) {

    var data = {
      groupPolicyNumber: this.filteredGroupPolicyList.find(x => x.id = entity.groupPolicyId).groupNumber,
      titleOfPolicy: entity.titleOfPolicy,
      accountNumber: entity.certificateNumber,
      insuredName: entity.insuredName,
      insuredDOB: entity.insuredDOB,
      insuredEffectiveDate: entity.insuredEffectiveDate,
      patientName: entity.patientName,
      patientDOB: entity.patientDOB,
      occupation: entity.occupation,
      dateOfIncident: entity.dateOfIncident,
      causeOfIncident: entity.causeOfIncident ? this.bancaCauseOfIncidents.find(x => x.id == entity.causeOfIncident).value : '',
      claimAmount: entity.claimAmount,
      claimAmountInUSD: entity.claimAmountInUSD,
      totalClaimAmount: entity.totalClaimAmount,
      claimTypeName: this.claimTypes.find(x => x.id == entity.claimTypeId).claimsTypeName,
      isBeneficiaryHiddenable: entity.bancaClaimSubmissionBeneficiaries.length > 0 ? false : true,
      bancaClaimSubmissionBeneficiaries: entity.bancaClaimSubmissionBeneficiaries,
    }

    return data;


  }

}




